import { TicketWithDetailsDto } from '@sib/api';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@sib/ui';
import {
  DocumentsTab,
  LogsTabForm,
} from '@spendbrain/modules/tickets/components/TicketDetails/Tabs';
import { useAppTranslation } from '@spendbrain/modules/tickets/hooks';

export enum TicketDetailsTabsSections {
  Logs = 'logs',
  Documents = 'documents',
}

interface TicketDetailsTabsProps {
  ticket?: TicketWithDetailsDto;
}

export const TicketDetailsTabs = ({ ticket }: TicketDetailsTabsProps) => {
  const { t } = useAppTranslation();

  return (
    <Tabs defaultValue={TicketDetailsTabsSections.Logs} className="h-full">
      <TabsList withIndicator className="mt-2 rounded-none bg-transparent p-0">
        <TabsTrigger
          value={TicketDetailsTabsSections.Logs}
          className="cursor-pointer rounded-none"
        >
          {t('components.ticketDetails.tabs.logs')}
        </TabsTrigger>
        <TabsTrigger
          value={TicketDetailsTabsSections.Documents}
          className="cursor-pointer rounded-none"
        >
          {t('components.ticketDetails.tabs.documents')}
        </TabsTrigger>
      </TabsList>
      <div className="border-border flex flex-col gap-4 border-t">
        <TabsContent value={TicketDetailsTabsSections.Logs}>
          <LogsTabForm ticket={ticket} />
        </TabsContent>
        <TabsContent value={TicketDetailsTabsSections.Documents}>
          <DocumentsTab documents={ticket?.documents} />
        </TabsContent>
      </div>
    </Tabs>
  );
};
